export default __webpack_public_path__ + "static/media/promo_00.6ac002f0.jpg";